import init, { SignalCenterWasm } from './wasm/signalkit';

export default class CryptoManager {
  signal: SignalCenterWasm | undefined;

  constructor() {}

  async initCrypto(userId: string) {
    await init();
    this.signal = new SignalCenterWasm(userId);
  }

  getKeyPacakge(): string {
    return this.signal!.getKeyPackage();
  }

  setKeyPackage(targetUserId: string, targetPackage: string) {
    return this.signal!.setKeyPackage(targetUserId, targetPackage);
  }

  encryptMessage(targetUserId: string, text: string): string {
    return this.signal!.encryptMessage(targetUserId, text);
  }

  decryptMessage(targetUserId: string, text: string, isMe: boolean): string {
    return this.signal!.decryptMessage(targetUserId, text, isMe);
  }
}
